import React from 'react';
import { useTranslation } from 'react-i18next';
import { GovSkeleton } from '@gov-design-system-ce/react';
import { LocalizeNameSpaceTypes } from '@gov-nx/core/service';
import { ContentLayout, LayoutGap } from '@gov-nx/ui/web';
import { generateRandomNumber } from '@gov-nx/utils/common';

export const MySubmissionsSkeleton = () => {
	const { t } = useTranslation(LocalizeNameSpaceTypes.Global);
	return (
		<ContentLayout>
			<LayoutGap className="flex justify-between">
				<GovSkeleton
					width="40px"
					height="40px"
					aria-label={t('loading.wcag.processing', {
						namespace: LocalizeNameSpaceTypes.Global,
					})}
					className="ml-auto"
				/>
				<MySubmissionsListSkeleton />
			</LayoutGap>
		</ContentLayout>
	);
};

export const MySubmissionsListSkeleton = () => {
	const { t } = useTranslation(LocalizeNameSpaceTypes.Global);

	return (
		<>
			{Array.from(Array(10))
				.fill(null)
				.map((_, index) => {
					const randomNumber = generateRandomNumber(40, 70);
					return (
						<div // eslint-disable-next-line react/no-array-index-key
							key={index}
							className="flex justify-between items-center p-6 mt-0!">
							<div
								className="flex items-center"
								style={{ width: randomNumber + '%' }}>
								<GovSkeleton
									width="100%"
									height="24px"
									aria-label={t('loading.wcag.processing', {
										namespace: LocalizeNameSpaceTypes.Global,
									})}
								/>
							</div>
							<div className="flex gap-4">
								<GovSkeleton
									width="150px"
									height="20px"
									aria-label={t('loading.wcag.processing', {
										namespace: LocalizeNameSpaceTypes.Global,
									})}
									className="mt-4 [ md:ml-auto md:mt-0 ]"
								/>
								<GovSkeleton
									width="20px"
									height="20px"
									aria-label={t('loading.wcag.processing', {
										namespace: LocalizeNameSpaceTypes.Global,
									})}
									className="hidden [ md:block md:ml-3 ]"
								/>
							</div>
						</div>
					);
				})}
		</>
	);
};
